import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';
import { footerData } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-slate-800 border-t border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div className="sm:col-span-2">
            <Link to="/" className="flex items-center mb-4 sm:mb-6">
              <img 
                src="/assets/logo/city-battery-secondary.svg" 
                alt="city-battery.energy" 
                className="h-[36px] w-auto"
              />
            </Link>
            <p className="text-sm sm:text-base text-slate-400 leading-relaxed max-w-md mb-4 sm:mb-6">
              {footerData.companyDescription}
            </p>
            
            {/* Social Links */}
            <div className="flex gap-3">
              <a 
                href={footerData.linkedInUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-slate-700 flex items-center justify-center text-slate-400 hover:bg-cyan-700 hover:text-white transition-colors"
              >
                <Linkedin className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a 
                href={`mailto:${footerData.contactEmail}`}
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-slate-700 flex items-center justify-center text-slate-400 hover:bg-cyan-700 hover:text-white transition-colors"
              >
                <Mail className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Kontakt</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a 
                  href={`mailto:${footerData.contactEmail}`}
                  className="text-sm sm:text-base text-slate-400 hover:text-cyan-400 transition-colors"
                >
                  {footerData.contactEmail}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Rechtliches</h3>
            <ul className="space-y-2 sm:space-y-3">
              {footerData.links.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.href}
                    className="text-sm sm:text-base text-slate-400 hover:text-cyan-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-slate-700">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-xs sm:text-sm text-slate-500">
              © {currentYear} city-battery.energy. Alle Rechte vorbehalten.
            </p>
            <p className="text-xs sm:text-sm text-slate-500">
              Energiezukunft. Heute gestalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
